function getDeliveryStations() {
	var delivery_stations = [
		{
			company: "Genentech - South San Francisco Campus"
			, locations: [
				"Building 5 Front Desk"
				, "Building 35 Front Desk"
				, "Building 40 Front Desk"
				, "Building 86 Front Desk"
			]
		},
		{
			company: "The Daisy Refillery"
			, locations: [
				"Pick Up Location 1"
				, "Pick Up Location 2"
				, "Pick Up Location 3"
			]
		}
	];

	return delivery_stations;
}

function getDeliveryStationLocations(company) {
	var locations = null;
	var delivery_stations = getDeliveryStations();

	var num_delivery_stations = delivery_stations.length;
	for(var i = 0; i < num_delivery_stations; i++) {
		var cur_delivery_station = delivery_stations[i];
		var cur_company = cur_delivery_station.company;

		if(cur_company == company) {
			locations = cur_delivery_station.locations;
			continue;
		}
	}

	return locations;
}